import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';
import { formatDateTime } from 'utils/formattedString';

const TIME_TITLE = {
  AWAITING_CONFIRMATION: {
    title: 'createdTime',
    value: 'createdTime',
  },
  CONFIRMED: {
    title: 'confirmedTime',
    value: 'confirmationTime',
  },
  DELIVERING: {
    title: 'deliveringTime',
    value: 'handedOverTime',
  },
  READY_TO_TRY: {
    title: 'readyToTryTime',
    value: 'readyToTryTime',
  },
  DELIVERY_SUCCESS: {
    title: 'completedTime',
    value: 'deliveryCompletedTime',
  },
  CANCELLED: {
    title: 'cancelledTime',
    value: 'cancelTime',
  },
};

export default function OrderSummary({ data }) {
  const { t } = useTranslation();

  const summaries = [
    {
      key: 1,
      text: t(`ordersTabTryBuy.${TIME_TITLE[data?.statusOms]?.title}`),
      value: formatDateTime(
        data?.[TIME_TITLE[data?.statusOms]?.value] || data?.createdAt,
      ),
    },
    {
      key: 2,
      text: t('ordersTabTryBuy.detail.channel'),
      value: upperFirst(data?.channelDisplay),
    },
    {
      key: 3,
      text: t('ordersTabTryBuy.detail.pickupStore'),
      value: (
        <span> {`${data?.location?.code} | ${data?.location?.name}`}</span>
      ),
    },
  ];

  return (
    <div className="p-[10px] border-[1px] border-border-dark-gray bg-white">
      <div className="bg-bg-ghost-white p-[10px] flex gap-[6px]">
        {summaries
          ?.filter((i: DynamicObjectType) => !!i?.text)
          ?.map((item: DynamicObjectType, index) => (
            <div
              key={`summary-${index.toString}`}
              className="text-highlight flex-1"
            >
              {item?.text}
              <div
                className="font-bold mt-[5px]"
                style={{
                  color: item?.color,
                }}
              >
                {item?.value}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
